import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexComponent',
  setup(__props) {

const uiTable = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/uiTable.vue"))
const alertComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/alertComponent.vue"))
const progressbarComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/progressbarComponent.vue"))
const checkboxComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/checkboxComponent.vue"))
const radioButtons = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/radioButtons.vue"))
const selectComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/selectComponent.vue"))
const inputComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/inputComponent.vue"))
const badgesComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/badgesComponent.vue"))
const tootipComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/tootipComponent.vue"))
const switchComponent = defineAsyncComponent(() => import("@/components/theme/table/tablecomponent/switchComponent.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bootstrap Tables",
      title: "Table Components"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(uiTable)),
        _createVNode(_unref(alertComponent)),
        _createVNode(_unref(progressbarComponent)),
        _createVNode(_unref(checkboxComponent)),
        _createVNode(_unref(radioButtons)),
        _createVNode(_unref(selectComponent)),
        _createVNode(_unref(inputComponent)),
        _createVNode(_unref(badgesComponent)),
        _createVNode(_unref(tootipComponent)),
        _createVNode(_unref(switchComponent))
      ])
    ])
  ], 64))
}
}

})